module.exports = __webpack_public_path__ + "media/images/pages/journal-632aa7f4b8efda4e0dfb2b0c595650be.svg";